import type { TabConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";

// ============================================================================
// COMMUNICATIONS DETAIL TABS CONFIGURATION
// ============================================================================

export const communicationsDetailTabs: TabConfig<any>[] = [
  // Core Information Group
  {
    id: "details",
    label: "Details",
    icon: "file-text",
    variant: "blue",
    group: "core",
    priority: 1,
    content: {
      type: "fields",
      layout: "grid",
      sections: [
        {
          id: "main-content",
          title: "Communication Description",
          fields: ["body"],
          layout: "full",
        },
        {
          id: "communication-info",
          title: "Communication Information",
          fields: ["type_id", "direction", "status", "occurred_at"],
          layout: "sidebar",
          gridColumns: 2,
        },
        {
          id: "contact-info",
          title: "Contact",
          fields: ["contact_id"],
          layout: "sidebar",
          gridColumns: 1,
        },
      ],
    },
  },
  {
    id: "company",
    label: "Company",
    icon: "building",
    variant: "red",
    group: "core",
    priority: 2,
    visible: (item: any) => !!(item).company_id || !!(item).company_name,
    content: {
      type: "custom",
      customComponent: "CommunicationsCompanyDisplay",
    },
  },
  {
    id: "contact",
    label: "Contact",
    icon: "user",
    variant: "blue",
    group: "core",
    priority: 2.5,
    visible: (item: any) => !!(item).contact_id || !!(item).contact_name,
    content: {
      type: "custom",
      customComponent: "CommunicationsContactDisplay",
    },
  },
  {
    id: "deals",
    label: "Deals",
    icon: "briefcase",
    variant: "green",
    group: "core",
    priority: 3,
    visible: (item: any) => !!(item).company_id,
    content: {
      type: "custom",
      customComponent: "CommunicationsDealsDisplay",
    },
  },
  {
    id: "tasks",
    label: "Tasks",
    icon: "check-square",
    variant: "orange",
    group: "core",
    priority: 4,
    visible: (item: any) => !!(item).company_id,
    content: {
      type: "custom",
      customComponent: "CommunicationsTasksDisplay",
    },
  },
  // Activity Group
  {
    id: "timeline",
    label: "Timeline",
    icon: "activity",
    variant: "purple",
    group: "activity",
    priority: 1,
    content: {
      type: "custom",
      customComponent: "CommunicationsTimelineDisplay",
    },
  },
  {
    id: "related-activities",
    label: "Related Activities",
    icon: "list",
    variant: "orange",
    group: "activity",
    priority: 2,
    content: {
      type: "custom",
      customComponent: "CommunicationsRelatedActivitiesDisplay",
    },
  },
  // Metadata Group
  {
    id: "metadata",
    label: "Metadata",
    icon: "info",
    variant: "purple",
    group: "metadata",
    priority: 1,
    // CommunicationsMetadataDisplay is a superset of the field list this tab
    // used to render (id / created_at / updated_at / external_id) plus the
    // email provenance card and the raw metadata JSON — the provenance detail
    // needed to answer "where did this message come from".
    content: {
      type: "custom",
      customComponent: "CommunicationsMetadataDisplay",
    },
  },
];
